export function getEnv() {
  const hostname = window.location.hostname;

  if (hostname.includes("dev-homebound")) return "dev";
  if (hostname.includes("qa-homebound")) return "qa";
  if (hostname.includes("homebound")) return "prod";
  return "local";
}
